import { ProvisioningEnum } from '@lib/resources/types';

const prefix = 'lumahealth/PatientPage';

export const ARCHIVE_INSURANCE_CARD = `${prefix}/ARCHIVE_INSURANCE_CARD`;
export const ARCHIVE_INSURANCE_CARD_ERROR = `${prefix}/ARCHIVE_INSURANCE_CARD_ERROR`;
export const ARCHIVE_INSURANCE_CARD_SUCCESS = `${prefix}/ARCHIVE_INSURANCE_CARD_SUCCESS`;

export const DELETE_INSURANCE_CARD = `${prefix}/DELETE_INSURANCE_CARD`;
export const DELETE_INSURANCE_CARD_ERROR = `${prefix}/DELETE_INSURANCE_CARD_ERROR`;
export const DELETE_INSURANCE_CARD_SUCCESS = `${prefix}/DELETE_INSURANCE_CARD_SUCCESS`;

export const DELETE_PATIENT = `${prefix}/DELETE_PATIENT`;
export const DELETE_PATIENT_SUCCESS = `${prefix}/DELETE_PATIENT_SUCCESS`;
export const DELETE_PATIENT_ERROR = `${prefix}/DELETE_PATIENT_ERROR`;

export const ITEMS_PER_PAGE = 30;

export const LOAD_PATIENT_JOURNEY = `${prefix}/LOAD_PATIENT_JOURNEY`;
export const LOAD_PATIENT_JOURNEY_SUCCESS = `${prefix}/LOAD_PATIENT_JOURNEY_SUCCESS`;
export const LOAD_PATIENT_JOURNEY_ERROR = `${prefix}/LOAD_PATIENT_JOURNEY_ERROR`;

export const LOAD_APPOINTMENTS = `${prefix}/LOAD_APPOINTMENTS`;
export const LOAD_APPOINTMENTS_SUCCESS = `${prefix}/LOAD_APPOINTMENTS_SUCCESS`;
export const LOAD_APPOINTMENTS_ERROR = `${prefix}/LOAD_APPOINTMENTS_ERROR`;

export const LOAD_EVENT_MESSAGES = `${prefix}/LOAD_EVENT_MESSAGES`;
export const LOAD_EVENT_MESSAGES_SUCCESS = `${prefix}/LOAD_EVENT_MESSAGES_SUCCESS`;
export const LOAD_EVENT_MESSAGES_ERROR = `${prefix}/LOAD_EVENT_MESSAGES_ERROR`;

export const LOAD_FILES = `${prefix}/LOAD_FILES`;
export const LOAD_FILES_SUCCESS = `${prefix}/LOAD_FILES_SUCCESS`;
export const LOAD_FILES_ERROR = `${prefix}/LOAD_FILES_ERROR`;

export const LOAD_OFFERS = `${prefix}/LOAD_OFFERS`;
export const LOAD_OFFERS_SUCCESS = `${prefix}/LOAD_OFFERS_SUCCESS`;
export const LOAD_OFFERS_ERROR = `${prefix}/LOAD_OFFERS_ERROR`;

export const LOAD_PATIENT = `${prefix}/LOAD_PATIENT`;
export const LOAD_PATIENT_SUCCESS = `${prefix}/LOAD_PATIENT_SUCCESS`;
export const LOAD_PATIENT_ERROR = `${prefix}/LOAD_PATIENT_ERROR`;

export const LOAD_WAITLISTS = `${prefix}/LOAD_WAITLISTS`;
export const LOAD_WAITLISTS_SUCCESS = `${prefix}/LOAD_WAITLISTS_SUCCESS`;
export const LOAD_WAITLISTS_ERROR = `${prefix}/LOAD_WAITLISTS_ERROR`;

export const RESET_FILES_REDUCER = `${prefix}/RESET_FILES_REDUCER`;

export const RESTORE_INSURANCE_CARD = `${prefix}/RESTORE_INSURANCE_CARD`;
export const RESTORE_INSURANCE_CARD_ERROR = `${prefix}/RESTORE_INSURANCE_CARD_ERROR`;
export const RESTORE_INSURANCE_CARD_SUCCESS = `${prefix}/RESTORE_INSURANCE_CARD_SUCCESS`;

export const SAVE_PATIENT = `${prefix}/SAVE_PATIENT`;
export const SAVE_PATIENT_SUCCESS = `${prefix}/SAVE_PATIENT_SUCCESS`;
export const SAVE_PATIENT_ERROR = `${prefix}/SAVE_PATIENT_ERROR`;

export const PATIENT_EDIT_FORM = 'PatientEditForm';

export const RESET_PATIENT_DATA = 'ResetPatientData';

export const PATIENT_TABS = [
  { key: 'chat', icon: 'message' },
  { key: 'journey', icon: 'timeline' },
  { key: 'appointments', icon: 'today' },
  { key: 'waitlists', icon: 'list' },
  { key: 'financial', icon: 'attach_money' },
  { key: 'offers', icon: 'local_offer' },
  { key: 'reminders', icon: 'alarm' },
  { key: 'files', icon: 'insert_drive_file' },
];

export enum PatientTabsEnum {
  Appointments = 'appointments',
  Chat = 'chat',
  Files = 'files',
  Financial = 'financial',
  Journey = 'journey',
  Offers = 'offers',
  Reminders = 'reminders',
  Waitlists = 'waitlists',
}

export const FILES_TAB_PROVISIONING = [
  ProvisioningEnum.Insurance,
  ProvisioningEnum.PrequalForm,
  ProvisioningEnum.IntakeForm,
  ProvisioningEnum.Feedback,
  // Providers provisioned w/ TH only should see forms - https://app.clickup.com/t/70a6z4
  ProvisioningEnum.Telehealth,
];

export const APPOITMENTS_TAB_PROVISIONING = [
  ProvisioningEnum.Reminder,
  ProvisioningEnum.Waitlist,
  ProvisioningEnum.Feedback,
  ProvisioningEnum.Scheduler,
  ProvisioningEnum.Telehealth,
];

export const OFFERS_TAB_PROVISIONING = [ProvisioningEnum.Waitlist, ProvisioningEnum.Scheduler];

export const FINANCIAL_TAB_PROVISIONING = [ProvisioningEnum.LumaPay, ProvisioningEnum.InsuranceVerification];

export const REMINDERS_TAB_PROVISIONING = [
  ProvisioningEnum.Reminder,
  ProvisioningEnum.Feedback,
  ProvisioningEnum.Followup,
  ProvisioningEnum.Referral,
  ProvisioningEnum.OutboundReferral,
  ProvisioningEnum.Recall,
  ProvisioningEnum.IntakeForm,
  ProvisioningEnum.PrequalForm,
  ProvisioningEnum.Telehealth,
];

export const GET_PATIENT_AUDIT = `${prefix}/GET_PATIENT_AUDIT`;
export const GET_PATIENT_AUDIT_SUCCESS = `${prefix}/GET_PATIENT_AUDIT_SUCCESS`;
export const GET_PATIENT_AUDIT_ERROR = `${prefix}/GET_PATIENT_AUDIT_ERROR`;

export const CHINESE_LANGUAGE_ID = 'zh';
export const TRADITIONAL_CHINESE_LANGUAGE_ID = 'zh-t';
export const CHINESE_CULTURE_LANGUAGE_OPTIONS = [
  { id: 'cn', label: 'Mandarin' },
  { id: 'hk', label: 'Cantonese' },
];
